(() => {
  const chat = document.querySelector('.ollaway-chat');
  if (!chat) return;
  const launch = chat.querySelector('.ollaway-chat-launch');
  const panel = chat.querySelector('.ollaway-chat-panel');
  const log = chat.querySelector('[role="log"]');
  const history = [];
  function close() { panel.hidden = true; launch.setAttribute('aria-expanded', 'false'); launch.focus(); }
  launch.addEventListener('click', () => {
    panel.hidden = !panel.hidden;
    launch.setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) chat.querySelector('.ollaway-chat-close').focus();
  });
  chat.querySelector('.ollaway-chat-close').addEventListener('click', close);
  chat.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) close(); });
  function append(text, role) {
    const p = document.createElement('p');
    p.className = role === 'user' ? 'ollaway-chat-question' : 'ollaway-chat-reply';
    p.textContent = text;
    log.append(p);
    log.scrollTop = log.scrollHeight;
  }
  chat.querySelectorAll('[data-answer]').forEach(button => button.addEventListener('click', () => {
    append(button.textContent, 'user'); append(button.dataset.answer, 'assistant');
    history.push({ role: 'user', content: button.textContent }, { role: 'assistant', content: button.dataset.answer });
  }));
  const form = chat.querySelector('form');
  if (!form) return;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const input = form.elements.message;
    const message = input.value.trim();
    const send = form.querySelector('button');
    if (!message || send.disabled) return;
    append(message, 'user'); input.value = ''; send.disabled = true; send.textContent = '…';
    try {
      const endpoint = new URL(chat.dataset.endpoint, location.origin);
      if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password) throw new Error('Invalid endpoint');
      const response = await fetch(endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: [...history.slice(-6), { role: 'user', content: message }] }), signal: AbortSignal.timeout(25000) });
      if (!response.ok) throw new Error('Unavailable');
      const result = await response.json();
      if (typeof result.answer !== 'string' || !result.answer.trim()) throw new Error('Empty answer');
      append(result.answer, 'assistant');
      history.push({ role: 'user', content: message }, { role: 'assistant', content: result.answer.slice(0, 3000) });
    } catch {
      append('I couldn’t connect just now. Try one of the quick questions above, or visit our contact page for help.', 'assistant');
      input.value = message;
    } finally { send.disabled = false; send.textContent = '↑'; input.focus(); }
  });
})();
